//Константы из SetupView
export default {
  loading: "Loading settings...",
  buttons: {
    save: "Save",
    create: "Create",
    copy: "Copy",
    copyto: "Copy to ...",
    delete: "Delete",
    cancel: "Cancel",
    show: "Preview",
    add_property: "Add",
    add: "Add",
    create_columns: "Generate columns",
    show_more: "Show more",
    loading: "Loading"
  },
  alpha: {
    clear: "Clear filter"
  },
  cmp: {
    graph_from: "Graph for %CMP_FROM%",
    graph_to: "Graph for %CMP_TO%"
  },
  confirm: {
    delete: "Please confirm view deletion"
  },
  titles: {
    preview: "Preview result",
    preview_disabled: "Preview is available only after saving",
    title_total: "Column total"
  },
  messages: {
    copy_view_to: "The current view will be copied to the asset with the following URI:",
    copy_view_to_success: "The current view has been copied to the asset with URI:"
  },
  labels: {
    no_value: "none",
    type: "View type"
  },
  placeholders: {
    filter_links: "Start typing to filter. ^ — only configured links.",
    filter_compare: "Start typing to filter. ^ — only graphs selected for comparison."
  },
  validation: {
    required: "This field is required",

    form_has_errors: "The form contains errors",

    columns_required: "Columns must be generated",
    min_values: "Minimum number of values: {{min}}",
    max_values: "Maximum number of values: {{max}}",
    fill_or_remove: "Please fill in the field or remove it",

    positive_integer: "Please enter a positive integer number",
    non_negative_integer: "Please enter a non-negative integer number",
    pattern: "Invalid value, required pattern: {{pattern}}",

    endpoint_required: "SPARQL endpoint is required",
    query_required: "SPARQL query is required"
  }
  
}
